(function () {
  document.querySelectorAll('[data-trust-marquee]').forEach(function (root) {
    if (root.dataset.trustMounted) return;
    root.dataset.trustMounted = 'true';
    var button = root.querySelector('[data-trust-pause]');
    var viewport = root.querySelector('.trust-marquee-window');
    var groups = root.querySelectorAll('.trust-marquee-group');
    if (!button || !viewport || groups.length !== 2) return;
    var originals = Array.from(groups[0].children);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pending;
    function copyItem(item, repeated) {
      var copy = item.cloneNode(true);
      copy.removeAttribute('role');
      copy.removeAttribute('data-shopify-editor-block');
      copy.setAttribute('aria-hidden', 'true');
      if (repeated) copy.setAttribute('data-trust-repeat', '');
      return copy;
    }
    function fill() {
      groups[0].replaceChildren.apply(groups[0], originals);
      var width = groups[0].getBoundingClientRect().width;
      if (!width || !originals.length) return;
      var repetitions = reduced.matches ? 1 : Math.max(1, Math.ceil(viewport.clientWidth / width));
      for (var pass = 1; pass < repetitions; pass++) {
        originals.forEach(function (item) { groups[0].appendChild(copyItem(item, true)); });
      }
      groups[1].replaceChildren.apply(groups[1], Array.from(groups[0].children).map(function (item) { return copyItem(item, false); }));
      root.style.setProperty('--trust-duration', (groups[0].getBoundingClientRect().width / 36) + 's');
    }
    function refresh() {
      cancelAnimationFrame(pending);
      pending = requestAnimationFrame(fill);
    }
    button.addEventListener('click', function () {
      var paused = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Resume trust messages' : 'Pause trust messages');
      button.textContent = paused ? '▶' : 'Ⅱ';
      root.classList.toggle('trust-is-paused', paused);
    });
    fill();
    if (document.fonts) document.fonts.ready.then(refresh);
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(viewport);
    else window.addEventListener('resize', refresh);
    reduced.addEventListener('change', refresh);
  });
})();
